import type { FaireProductEntity } from "../../entity_types/product";

export const p_vusrvvreyk: FaireProductEntity = {
  token: "p_vusrvvreyk",
  type: "product",
  name: "Mineral Wash Round Neck Sweater Top",
  brandToken: "b_dilw26syov",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/55121833a198b2fb08d63872cee2b64b51e54d57470c9405b7d0ddeaaa189963.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/278534d70d02a0fb1a86d64633b4f07165779d2d99966d80ddc5bea9bcb62dff.jpeg",
    "https://cdn.faire.com/fastly/2a70e6e7be23a539fe79ab6b4d2473eb52ea2543d4902c3c960a6c5d2e52f73f.jpeg",
    "https://cdn.faire.com/fastly/88fcf17fda293408689dc21654aa3dfecd3577cdc05576c8a112c831c348bced.jpeg",
    "https://cdn.faire.com/fastly/ade996fc3b89d81ae2b3f7aa8d18d26f3db68ff4645607fb7fb8616d26bc3c8b.jpeg",
    "https://cdn.faire.com/fastly/1bbcb8edd820c0c4c89892d35e8f54c841332f63737bf2db3204a9461a6ec84a.jpeg",
    "https://cdn.faire.com/fastly/72cc33090b4a61cc38a8e9b86549a04e08500dd83b5eef61325ae6355592eb62.jpeg",
    "https://cdn.faire.com/fastly/5872279dc2c22f129ee97e57f12b392ff4f2df11381c3596f326bfa00d85e613.jpeg",
    "https://cdn.faire.com/fastly/0e00fd5a70bfe0c53058fc54e0ebae294a6b2d7c9f6fe0192d841a09468b6a4e.jpeg",
    "https://cdn.faire.com/fastly/48376cefee9e9a1c9611232bc15a68191d906ef416d4090390a04c54060e2c09.jpeg",
    "https://cdn.faire.com/fastly/9415c0b447227a930bb4377de7a631296fda8817fc472694d8f9ceede309b875.jpeg",
    "https://cdn.faire.com/fastly/91cc99a5cb1170d2782fb3db6f1290e9e9b55ede591a024fccc665ac8b88dd0e.jpeg",
  ],
  priceDollars: 29.02,
  description:
    "Mineral-washed sweater top with peasant sleeves and a round neckline. This cozy knit features a front pocket detail and a ribbed texture. Perfect for adding a touch of texture and style to your casual look.",
  tags: [],
  msrpDollars: 58.03,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:45.312Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
